import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

// Utils
import PageUrlsUtils from 'Shared/utils/PageUrls.utils';
import { trackClickQuickStartGuideCTA } from 'Shared/tracking/tracking';

// Types
import { QuickStartGuideItemIDs } from '../QuickStartGuideItems.constants';

// Hooks
import useUpdateQuickStartGuideFlag from '../useUpdateQuickStartGuideFlag';

// Selectors
import { getOneOnOneWorkspaces } from 'Shared/selectors/workspace';

// Components
import { WpButton, WpButtonGroup } from 'Wpds/components/button';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { Illustrations, WpIllustration } from 'Wpds/components/illustration';
import { useTranslation } from 'Shared/contexts/TranslationsContext';

// Styles
import './GiveKudosStep.scss';

type Props = {
  navigateToList: Function;
};

const GiveKudosStep = ({ navigateToList }: Props) => {
  const history = useHistory();
  const step = QuickStartGuideItemIDs.giveKudos;
  const { tr } = useTranslation();

  const oneOnOneWorkspaces = useSelector(state => getOneOnOneWorkspaces(state));
  const teamSyncWorkspace = useSelector(state => state.workspaces.find(({ isTeamSync }) => isTeamSync));
  const workspaceId = oneOnOneWorkspaces[0]?.id || teamSyncWorkspace.id;

  const { handleSkipItem, hasBeenSet } = useUpdateQuickStartGuideFlag();
  const [isSet] = useState(hasBeenSet(step));

  const handleKudoClick = () => {
    trackClickQuickStartGuideCTA(step);
    history.push(PageUrlsUtils.makeWorkspaceRecognitionRequestNew(workspaceId));
  };

  const handleSkipClick = () => {
    handleSkipItem(step);
    navigateToList();
  };

  useEffect(() => {
    if (!isSet && hasBeenSet(step)) navigateToList();
  }, [isSet, hasBeenSet]);

  const baseClassName = 'GiveKudosStep';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__button`}>
        <WpButtonGroup stacked>
          <WpButton size="lg" onClick={handleKudoClick}>
            <WpIcon name="stars" />
            {tr('perform.onboarding.qsg.give_kudos.primary_cta')}
          </WpButton>
          {!isSet && (
            <WpButton size="lg" onClick={handleSkipClick} variant="tertiary">
              {tr('perform.onboarding.qsg.common.skip')}
            </WpButton>
          )}
        </WpButtonGroup>
      </div>
      <WpIllustration className={`${baseClassName}__image`} src={Illustrations.high_fiving_purple_bg} />
    </div>
  );
};
export default GiveKudosStep;
